'use strict';

(function () {
	// Bio cards (user + contact) use KTMenu + Popper fixed strategy.
	// Dismiss them on any scroll (including nested DataTables bodies)
	// so they do not stick to the viewport.
	if (window._avatarMenuScrollBound) {
		return;
	}
	window._avatarMenuScrollBound = true;

	document.addEventListener('scroll', function () {
		var items = document.querySelectorAll(
			'.contact_profile_avatar .show.menu-dropdown[data-kt-menu-trigger]'
		);
		if (!items.length) {
			return;
		}
		for (var i = 0; i < items.length; i++) {
			var item = items[i];
			var menu = window.KTMenu?.getInstance?.(item);
			menu?.hide?.(item);
		}
	}, { passive: true, capture: true });
})();
